import { t } from 'i18next';

export enum ProjectExceptionType {
  BLACKLIST = 'BLACKLIST',
  WHITELIST = 'WHITELIST',
}

export const getExceptionTypeLabel = (type: ProjectExceptionType): string => {
  const labels = {
    [ProjectExceptionType.BLACKLIST]: t('exceptionsTypes.blacklist'),
    [ProjectExceptionType.WHITELIST]: t('exceptionsTypes.whitelist'),
  };

  return labels[type] || type;
};
